import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { PublicProfile } from '../../../modules/Profile/PublicProfile/PublicProfile';
import { EditProfile } from '../../../modules/Profile/EditProfile/EditProfile';
import { Chat } from '../../../modules/Profile/Chat/Chat';
import { Networking } from '../../../modules/Profile/Networking/Networking';
import { MyWallet } from '../../../modules/Edu/MyWallet';
import { ProfileRoutes } from './types/routes';

export const ProfileRouter: React.FC = () => {
  return (
    <div className="mx-auto w-full grow !pt-24 sm-max:p-2">
      <Routes>
        <Route path={ProfileRoutes.user + '/:id'} element={<PublicProfile />} />
        <Route path={ProfileRoutes.me} element={<PublicProfile />} />
        <Route path={ProfileRoutes.edit} element={<EditProfile />} />
        <Route path={ProfileRoutes.chat} element={<Chat />} />
        <Route path={ProfileRoutes.networking} element={<Networking />} />
        <Route path={ProfileRoutes.wallet} element={<MyWallet />} />
      </Routes>
    </div>
  );
};
